import { LOAD_ORDER_REQUEST, LOAD_ORDER_SUCCESS, LOAD_ORDER_ERROR, } from '../types';
import { getToken } from '../auth';
export const loadOrderRequest = (number) => ({
    type: LOAD_ORDER_REQUEST,
    payload: number,
});
export const loadOrderSuccess = (data) => ({
    type: LOAD_ORDER_SUCCESS,
    payload: {
        data,
    },
});
export const loadOrderError = (number, error) => ({
    type: LOAD_ORDER_ERROR,
    payload: {
        number,
        error,
    },
    error: true,
});
export const loadOrder = (orderNumber) => () => async (dispatch, getState, { chord }) => {
    dispatch(loadOrderRequest(orderNumber));
    try {
        await dispatch(getToken());
        const authToken = getState().auth.token;
        const response = await chord.oms.getOrder({ number: orderNumber }, authToken);
        dispatch(loadOrderSuccess(response));
        return response;
    }
    catch (error) {
        dispatch(loadOrderError(orderNumber, error));
        throw error;
    }
};
